import(/* webpackMode: "eager" */ "/home/hpbs/frontend/components/containers/Articles/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/hpbs/frontend/components/containers/Competencies/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/hpbs/frontend/components/containers/Form/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/hpbs/frontend/components/containers/News/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/hpbs/frontend/components/containers/OurClients/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/hpbs/frontend/components/containers/Projects/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/hpbs/frontend/components/containers/Specialists/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/hpbs/frontend/components/containers/Target/TargetBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/hpbs/frontend/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/hpbs/frontend/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/home/hpbs/frontend/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/home/hpbs/frontend/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
